import { jsx as _jsx } from "react/jsx-runtime";
import { Icon } from "./Icon";
/**
 * ChevronIcon - A chevron/arrow icon commonly used for expand/collapse indicators
 */
export const ChevronIcon = ({ size, color = "#6B7280", direction = "down", variant = "small", className = "", style, ...props }) => {
    const rotationMap = {
        down: 0,
        up: 180,
        left: 90,
        right: -90,
    };
    const rotation = rotationMap[direction];
    const transform = rotation !== 0 ? `rotate(${rotation}deg)` : undefined;
    // Determine size and viewBox based on variant
    const iconSize = size || (variant === "medium" ? 16 : 12);
    const viewBox = variant === "medium" ? "0 0 16 16" : "0 0 12 12";
    const path = variant === "medium"
        ? "M4 6L8 10L12 6" // 16x16 viewBox path
        : "M3 7L6 4L9 7"; // 12x12 viewBox path
    return (_jsx(Icon, { size: iconSize, color: color, viewBox: viewBox, className: className, style: {
            transform,
            transition: "transform 0.2s",
            ...style
        }, ...props, children: _jsx("path", { d: path, stroke: color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }) }));
};
